import useEffectOnMount from "../useEffectOnMount";
import scrollUp from "./scrollUp";

export default function useScrollUpOnMount() {
  useEffectOnMount(scrollUp);
}
